import { defineBlokkliEditAdapter } from '#blokkli/adapter'
import drupalGraphlMiddlewareAdapter from '#blokkli/adapter/drupal/graphqlMiddleware'

export default defineBlokkliEditAdapter(async (ctx) => {
  const baseAdapter = await drupalGraphlMiddlewareAdapter(ctx)
  const router = useRouter()
  const route = useRoute()

  return {
    ...baseAdapter,
    changeLanguage: function (translation) {
      const path = translation.url.includes('http')
        ? new URL(translation.url).pathname
        : translation.url
      return router.push({
        path,
        query: route.query,
      })
    },
  }
})
